import { difference, each, isEmpty, size } from 'lodash'
import { removeInvalidFirebaseChars } from 'common/utils/fileUploading/nameAndIdUtils'
import { updateFirebase } from 'modules/App/globalApi'

export const getTagsList = (tags) => {
  if (!tags || size(tags) === 0) return []

  let tagsList = []
  each(tags, (_, tag) => {
    tagsList.push(tag)
  })

  return tagsList
}

export const getUpdatedContent = ({ prevItems, currItems, contentId, contentType, programId }) => {
  const removedItems = difference(prevItems, currItems)
  const addedItems = difference(currItems, prevItems)

  let itemsUpdate = {}
  each(addedItems, (item) => {
    const validItem = removeInvalidFirebaseChars(item)
    if (contentType === 'workout' && programId) {
      itemsUpdate[`${validItem}/${contentId}`] = { type: contentType, programId }
    } else {
      itemsUpdate[`${validItem}/${contentId}`] = { type: contentType }
    }
  })
  each(removedItems, (item) => {
    itemsUpdate[`${item}/${contentId}`] = null
  })

  return itemsUpdate
}

/**
 * The four content tag facets an org indexes, mapped from the field on the content item to the
 * key any write error is reported under. Every facet has to be handled: an org's list of values
 * for a facet is derived from the keys under it, so a facet left out of a delete keeps values
 * that point at content which no longer exists, and no page in the dashboard can remove one.
 */
const CONTENT_TAG_FACETS = {
  difficulty: 'difficultyErr',
  equipment: 'equipmentErr',
  instructors: 'instrErr',
  tags: 'tagsErr',
}

/**
 * @param {{updateType: ('add'|'remove')}}
 */
export const updateItemContentTags = async ({ orgId, item, contentId, contentType, programId, updateType }) => {
  let errors = {
    difficultyErr: null,
    equipmentErr: null,
    instrErr: null,
    tagsErr: null,
  }

  for (const [facet, errorKey] of Object.entries(CONTENT_TAG_FACETS)) {
    const facetPath = `coachOrgs/${orgId}/contentTags/${facet}`
    const facetUpdate = getUpdatedContent({
      prevItems: updateType === 'add' ? [] : item?.[facet],
      currItems: updateType === 'remove' ? [] : item?.[facet],
      contentId,
      programId,
      contentType,
    })

    if (!isEmpty(facetUpdate)) {
      const { error } = await updateFirebase(facetPath, facetUpdate)
      errors[errorKey] = error
    }
  }

  return errors
}
